import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {BrowserModule} from '@angular/platform-browser';
import {SharedComponentsModule} from '../../bonding_shared/components/shared-components.module';
import {FormsModule} from '@angular/forms';
import {EventComponent} from './event.component';
import {BusinessObjectInfoModule} from '../business-object-info/business-object-info.module';

@NgModule({
  imports: [RouterModule, BrowserModule, SharedComponentsModule, FormsModule, BusinessObjectInfoModule],
  declarations: [EventComponent],
  exports: [],
  providers: [],
})
export class EventModule {}
